var exports = {
  "Nr": "x234b8571--774659--card",
  "Sl": "x234b8571--774659--image",
  "rf": "x234b8571--774659--body",
  "AS": "x234b8571--774659--item",
  "DD": "x234b8571--774659--title",
  "DY": "x234b8571--774659--reliable",
  "WR": "x234b8571--774659--apartments",
  "Zk": "x234b8571--774659--card--single",
};

module.exports = exports;
